import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    LandingPageRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options?.search, options?.hash),
    },
    BlogListRoute: {
        to: "/blog",
        build: (options) => interpolatePath("/blog", undefined, options?.search, options?.hash),
    },
    BlogPostRoute: {
        to: "/blog/:slug",
        build: (options) => interpolatePath("/blog/:slug", options.params, options?.search, options?.hash),
    },
    ComparatorRoute: {
        to: "/comparateur",
        build: (options) => interpolatePath("/comparateur", undefined, options?.search, options?.hash),
    },
    HelpRoute: {
        to: "/help",
        build: (options) => interpolatePath("/help", undefined, options?.search, options?.hash),
    },
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options?.search, options?.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options?.search, options?.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options?.search, options?.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options?.search, options?.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options?.search, options?.hash),
    },
    AccountRoute: {
        to: "/account",
        build: (options) => interpolatePath("/account", undefined, options?.search, options?.hash),
    },
    TradingJournalRoute: {
        to: "/trading-journal",
        build: (options) => interpolatePath("/trading-journal", undefined, options?.search, options?.hash),
    },
    TradingAnalyticsRoute: {
        to: "/trading-analytics",
        build: (options) => interpolatePath("/trading-analytics", undefined, options?.search, options?.hash),
    },
    TradeDetailRoute: {
        to: "/trade/:tradeId",
        build: (options) => interpolatePath("/trade/:tradeId", options.params, options?.search, options?.hash),
    },
    TradingAccountsRoute: {
        to: "/trading-accounts",
        build: (options) => interpolatePath("/trading-accounts", undefined, options?.search, options?.hash),
    },
    PlaybookRoute: {
        to: "/playbook",
        build: (options) => interpolatePath("/playbook", undefined, options?.search, options?.hash),
    },
    PropFirmManagerRoute: {
        to: "/prop-firm-manager",
        build: (options) => interpolatePath("/prop-firm-manager", undefined, options?.search, options?.hash),
    },
    AccountDetailRoute: {
        to: "/account/:accountId",
        build: (options) => interpolatePath("/account/:accountId", options.params, options?.search, options?.hash),
    },
    AccountGroupDetailRoute: {
        to: "/account-group/:groupId",
        build: (options) => interpolatePath("/account-group/:groupId", options.params, options?.search, options?.hash),
    },
    EdgyReportsRoute: {
        to: "/my-analyses",
        build: (options) => interpolatePath("/my-analyses", undefined, options?.search, options?.hash),
    },
    ReportsRoute: {
        to: "/reports",
        build: (options) => interpolatePath("/reports", undefined, options?.search, options?.hash),
    },
    ReportDetailRoute: {
        to: "/reports/:reportId",
        build: (options) => interpolatePath("/reports/:reportId", options.params, options?.search, options?.hash),
    },
    TradingRoutinesRoute: {
        to: "/trading-routines",
        build: (options) => interpolatePath("/trading-routines", undefined, options?.search, options?.hash),
    },
    TradingGoalsRoute: {
        to: "/trading-goals",
        build: (options) => interpolatePath("/trading-goals", undefined, options?.search, options?.hash),
    },
    NotebookRoute: {
        to: "/notebook",
        build: (options) => interpolatePath("/notebook", undefined, options?.search, options?.hash),
    },
    NotebookNoteRoute: {
        to: "/notebook/:noteId",
        build: (options) => interpolatePath("/notebook/:noteId", options.params, options?.search, options?.hash),
    },
    FundamentalAnalysisRoute: {
        to: "/fundamental-analysis",
        build: (options) => interpolatePath("/fundamental-analysis", undefined, options?.search, options?.hash),
    },
    TradingSessionsRoute: {
        to: "/trading-sessions",
        build: (options) => interpolatePath("/trading-sessions", undefined, options?.search, options?.hash),
    },
    SessionDetailRoute: {
        to: "/session/:sessionId",
        build: (options) => interpolatePath("/session/:sessionId", options.params, options?.search, options?.hash),
    },
    SessionShareRoute: {
        to: "/session/share/:token",
        build: (options) => interpolatePath("/session/share/:token", options.params, options?.search, options?.hash),
    },
    TradingDashboardRoute: {
        to: "/dashboard",
        build: (options) => interpolatePath("/dashboard", undefined, options?.search, options?.hash),
    },
    LayoutSharePreviewRoute: {
        to: "/dashboard/layouts/share/:token",
        build: (options) => interpolatePath("/dashboard/layouts/share/:token", options.params, options?.search, options?.hash),
    },
    CustomPageRoute: {
        to: "/p/:pageId",
        build: (options) => interpolatePath("/p/:pageId", options.params, options?.search, options?.hash),
    },
    AboutPageRoute: {
        to: "/about",
        build: (options) => interpolatePath("/about", undefined, options?.search, options?.hash),
    },
    AffiliationRoute: {
        to: "/affiliation",
        build: (options) => interpolatePath("/affiliation", undefined, options?.search, options?.hash),
    },
    AffiliateRoute: {
        to: "/affiliate",
        build: (options) => interpolatePath("/affiliate", undefined, options?.search, options?.hash),
    },
    PrivacyPageRoute: {
        to: "/privacy",
        build: (options) => interpolatePath("/privacy", undefined, options?.search, options?.hash),
    },
    TermsPageRoute: {
        to: "/terms",
        build: (options) => interpolatePath("/terms", undefined, options?.search, options?.hash),
    },
    DisclosuresPageRoute: {
        to: "/disclosures",
        build: (options) => interpolatePath("/disclosures", undefined, options?.search, options?.hash),
    },
    JournalDeTradingRoute: {
        to: "/journal-de-trading",
        build: (options) => interpolatePath("/journal-de-trading", undefined, options?.search, options?.hash),
    },
    FeaturePropFirmManagerRoute: {
        to: "/fonctionnalites/prop-firm-manager",
        build: (options) => interpolatePath("/fonctionnalites/prop-firm-manager", undefined, options?.search, options?.hash),
    },
    FeatureAnalyticsRoute: {
        to: "/fonctionnalites/analytics-trading",
        build: (options) => interpolatePath("/fonctionnalites/analytics-trading", undefined, options?.search, options?.hash),
    },
    FeatureSessionsRoute: {
        to: "/fonctionnalites/sessions-de-trading",
        build: (options) => interpolatePath("/fonctionnalites/sessions-de-trading", undefined, options?.search, options?.hash),
    },
    FeatureMentorRoute: {
        to: "/fonctionnalites/mode-mentor",
        build: (options) => interpolatePath("/fonctionnalites/mode-mentor", undefined, options?.search, options?.hash),
    },
    FeatureDashboardRoute: {
        to: "/fonctionnalites/dashboard-trading",
        build: (options) => interpolatePath("/fonctionnalites/dashboard-trading", undefined, options?.search, options?.hash),
    },
    IntegrationsRoute: {
        to: "/integrations",
        build: (options) => interpolatePath("/integrations", undefined, options?.search, options?.hash),
    },
    SolutionDebutantRoute: {
        to: "/solutions/prop-trader-debutant",
        build: (options) => interpolatePath("/solutions/prop-trader-debutant", undefined, options?.search, options?.hash),
    },
    SolutionMultiComptesRoute: {
        to: "/solutions/prop-trader-multi-comptes",
        build: (options) => interpolatePath("/solutions/prop-trader-multi-comptes", undefined, options?.search, options?.hash),
    },
    SolutionCoachRoute: {
        to: "/solutions/coach-trading",
        build: (options) => interpolatePath("/solutions/coach-trading", undefined, options?.search, options?.hash),
    },
    VsTradeZellaRoute: {
        to: "/vs/tradezella",
        build: (options) => interpolatePath("/vs/tradezella", undefined, options?.search, options?.hash),
    },
    VsTraderSyncRoute: {
        to: "/vs/tradersync",
        build: (options) => interpolatePath("/vs/tradersync", undefined, options?.search, options?.hash),
    },
    VsNotionRoute: {
        to: "/vs/notion",
        build: (options) => interpolatePath("/vs/notion", undefined, options?.search, options?.hash),
    },
    VsExcelRoute: {
        to: "/vs/excel",
        build: (options) => interpolatePath("/vs/excel", undefined, options?.search, options?.hash),
    },
    BestJournalRoute: {
        to: "/meilleur-journal-de-trading",
        build: (options) => interpolatePath("/meilleur-journal-de-trading", undefined, options?.search, options?.hash),
    },
    AlternativesRoute: {
        to: "/alternatives-journal-de-trading",
        build: (options) => interpolatePath("/alternatives-journal-de-trading", undefined, options?.search, options?.hash),
    },
    PricingRoute: {
        to: "/tarifs",
        build: (options) => interpolatePath("/tarifs", undefined, options?.search, options?.hash),
    },
    CheckoutResultRoute: {
        to: "/checkout",
        build: (options) => interpolatePath("/checkout", undefined, options?.search, options?.hash),
    },
    FileUploadRoute: {
        to: "/file-upload",
        build: (options) => interpolatePath("/file-upload", undefined, options?.search, options?.hash),
    },
    AdminRoute: {
        to: "/admin",
        build: (options) => interpolatePath("/admin", undefined, options?.search, options?.hash),
    },
    AdminUsersRoute: {
        to: "/admin/users",
        build: (options) => interpolatePath("/admin/users", undefined, options?.search, options?.hash),
    },
    NotFoundRoute: {
        to: "*",
        build: (options) => interpolatePath("*", options.params, options?.search, options?.hash),
    },
    AdminMessagesRoute: {
        to: "/admin/messages",
        build: (options) => interpolatePath("/admin/messages", undefined, options?.search, options?.hash),
    },
    AdminPropFirmsRoute: {
        to: "/admin/propfirms",
        build: (options) => interpolatePath("/admin/propfirms", undefined, options?.search, options?.hash),
    },
    AdminBlogRoute: {
        to: "/admin/blog",
        build: (options) => interpolatePath("/admin/blog", undefined, options?.search, options?.hash),
    },
    AdminComparatorRoute: {
        to: "/admin/comparator",
        build: (options) => interpolatePath("/admin/comparator", undefined, options?.search, options?.hash),
    },
    AdminAffiliatesRoute: {
        to: "/admin/affiliates",
        build: (options) => interpolatePath("/admin/affiliates", undefined, options?.search, options?.hash),
    },
    AdminB2bRoute: {
        to: "/admin/b2b",
        build: (options) => interpolatePath("/admin/b2b", undefined, options?.search, options?.hash),
    },
    AdminBlogNewRoute: {
        to: "/admin/blog/new",
        build: (options) => interpolatePath("/admin/blog/new", undefined, options?.search, options?.hash),
    },
    AdminBlogEditRoute: {
        to: "/admin/blog/:id/edit",
        build: (options) => interpolatePath("/admin/blog/:id/edit", options.params, options?.search, options?.hash),
    },
    AdminBlogCategoriesRoute: {
        to: "/admin/blog/categories",
        build: (options) => interpolatePath("/admin/blog/categories", undefined, options?.search, options?.hash),
    },
    AdminHelpRoute: {
        to: "/admin/help",
        build: (options) => interpolatePath("/admin/help", undefined, options?.search, options?.hash),
    },
    AdminHelpQuestionsRoute: {
        to: "/admin/help/questions",
        build: (options) => interpolatePath("/admin/help/questions", undefined, options?.search, options?.hash),
    },
    AdminHelpNewRoute: {
        to: "/admin/help/new",
        build: (options) => interpolatePath("/admin/help/new", undefined, options?.search, options?.hash),
    },
    AdminHelpEditRoute: {
        to: "/admin/help/:id/edit",
        build: (options) => interpolatePath("/admin/help/:id/edit", options.params, options?.search, options?.hash),
    },
    AdminLayoutsRoute: {
        to: "/admin/layouts",
        build: (options) => interpolatePath("/admin/layouts", undefined, options?.search, options?.hash),
    },
    MentorDashboardRoute: {
        to: "/mentor",
        build: (options) => interpolatePath("/mentor", undefined, options?.search, options?.hash),
    },
    StudentOverviewRoute: {
        to: "/mentor/student/:studentId",
        build: (options) => interpolatePath("/mentor/student/:studentId", options.params, options?.search, options?.hash),
    },
    StudentJournalRoute: {
        to: "/mentor/student/:studentId/journal",
        build: (options) => interpolatePath("/mentor/student/:studentId/journal", options.params, options?.search, options?.hash),
    },
    StudentDashboardRoute: {
        to: "/mentor/student/:studentId/dashboard",
        build: (options) => interpolatePath("/mentor/student/:studentId/dashboard", options.params, options?.search, options?.hash),
    },
    StudentAnalyticsRoute: {
        to: "/mentor/student/:studentId/analytics",
        build: (options) => interpolatePath("/mentor/student/:studentId/analytics", options.params, options?.search, options?.hash),
    },
    StudentSessionsRoute: {
        to: "/mentor/student/:studentId/sessions",
        build: (options) => interpolatePath("/mentor/student/:studentId/sessions", options.params, options?.search, options?.hash),
    },
    StudentSessionDetailRoute: {
        to: "/mentor/student/:studentId/session/:sessionId",
        build: (options) => interpolatePath("/mentor/student/:studentId/session/:sessionId", options.params, options?.search, options?.hash),
    },
    StudentPropFirmRoute: {
        to: "/mentor/student/:studentId/propfirm",
        build: (options) => interpolatePath("/mentor/student/:studentId/propfirm", options.params, options?.search, options?.hash),
    },
    AcceptInvitationRoute: {
        to: "/mentor/invite/accept/:token",
        build: (options) => interpolatePath("/mentor/invite/accept/:token", options.params, options?.search, options?.hash),
    },
    DisciplineManagerRoute: {
        to: "/discipline-manager",
        build: (options) => interpolatePath("/discipline-manager", undefined, options?.search, options?.hash),
    },
    DisciplineManagerNoteRoute: {
        to: "/discipline-manager/note/:noteId",
        build: (options) => interpolatePath("/discipline-manager/note/:noteId", options.params, options?.search, options?.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map